import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import Loader from '../../components/Loader';
import RecommendListing from '../../components/Home/RecommendListing';
import MostViewedListing from '../../components/Home/MostViewedListing';
import PopularLocation from '../../components/Home/PopularLocation';
import ImageBanner from '../../components/Home/ImageBanner';
import StaticInfoBlock from '../../components/Home/StaticInfoBlock';
import HomeBanner from '../../components/Home/HomeBanner';

import { closeWishListModal } from '../../actions/WishList/modalActions';
import s from './Home.css';
import l from '../../components/Skeleton/Skeleton.css';

const Homepage = ({ layoutType, wholeData }) => {
  const dispatch = useDispatch();


  useEffect(() => {
    return () => {
      dispatch(closeWishListModal());
    };
  }, [dispatch]);

  if (!wholeData) return <Loader type="text" />;

  return (
    <div className={s.root}>
      <HomeBanner layoutType={layoutType} wholeData={wholeData} />
      <RecommendListing />
      <MostViewedListing />
      <PopularLocation />
      <ImageBanner />
      <StaticInfoBlock />
    </div>
  );
};

export default injectIntl(
  withStyles(s, l)(Homepage)
);
